import type { ReactNode } from 'react';
import { useT } from '../i18n/index.js';
import './ConfirmModal.de.js';
import './ConfirmModal.fr.js';

interface Props {
  open: boolean;
  title: string;
  children?: ReactNode;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({ open, title, children, confirmLabel, danger, onConfirm, onCancel }: Props) {
  const t = useT();
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="close-btn" onClick={onCancel}>×</button>
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onCancel}>{t('Cancel')}</button>
          {/* ATTEST §4: a control that commits says so. A confirm dialogue always commits. */}
          <button className={`btn ${danger ? 'btn-danger' : 'btn-accent'}`} onClick={onConfirm}>{confirmLabel ?? t('Confirm')}</button>
        </div>
      </div>
    </div>
  );
}
